import styled from 'styled-components';
import { Dimmer } from 'semantic-ui-react';
import { sideMenuWidth } from '../../styles';

export const MenuContainer = styled.ul`
  margin: 0;
  padding: 0;
  list-style-type: none;
`;

/**
 * backdrop style
 * NOTE: used for `MenuItem` component too
 */
export const Backdrop = styled(Dimmer)`
  &,
  &.ui.dimmer {
    position: fixed;
    left: ${sideMenuWidth}px !important;
    z-index: -2;
  }
`;
